// 重写elementui el-form-item组件，加入表单校验
<template>
  <form-item
    :label="getLabel"
    :prop="prop"
    :rules="getRules"
    :class="hiddenErrorText?'hiddenError':''"
  >
    <slot></slot>
  </form-item>
</template>
<script>
// 引入elementui的el-form-item组件
import { FormItem } from "element-ui";
export default {
  components: {
    FormItem
  },
  props: {
    label: {
      type: String
    },
    prop: {
      type: String
    },
    rules: {
      type: Object
    },
    required: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    hiddenErrorText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getRules() {
      if (!this.label) return [];
      var rulesObj = Object.assign(
        {},
        { required: this.required },
        this.rules || {}
      );
      // 获取label名称
      var labelName = this.label.split(":")[0];
      rulesObj.labelName = labelName;
      var rulesParams = this.validate(rulesObj);
      return rulesParams;
    },
    getLabel() {
      if (this.hiddenLabel) {
        return "";
      } else {
        return this.label;
      }
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.hiddenError {
  margin-bottom: 0px;
  :global(.el-form-item__error) {
    color: yellow;
    display: none;
    line-height: 0;
    position: initial;
  }
}
</style>
